import { useTranslation } from 'react-i18next'
import React from 'react'
import { DataTitle } from '../AverageTraffic/AverageTraffic.styles'
import { StyledWrapper, TitleWrapper } from '../SharedOverview.styles'

function NoOverviewComponentData({ title }: { title: string }): JSX.Element {
  const { t } = useTranslation()

  return (
    <StyledWrapper>
      <TitleWrapper>
        {t(title)}
      </TitleWrapper>
      <DataTitle>
        {t('placeme.overview.no_data')}
      </DataTitle>
    </StyledWrapper>
  )
}

export default NoOverviewComponentData
